import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const FloorGraphics = () => {

    const servicesFaqData = [
        { 
            question: "What customisation options are available for floor graphics?", 
            answer: "Printingy offers extensive customisation options for floor graphics, including sizes, shapes, and materials. Our custom floor graphic printing services allow you to incorporate vibrant colours, logos, and tailored designs that align with your branding. Options such as anti-slip finishes and UV-resistant materials ensure your graphics are durable and safe for various applications."
        },
        { 
            question: "Does Printingy handle bulk orders for floor graphics?", 
            answer: "Yes, Printingy specialises in bulk floor graphics printing, catering to businesses and organisations with large-scale needs. Bulk printing ensures consistent quality and cost-effective solutions for high-traffic areas, promotional campaigns, and events. Our advanced production processes guarantee reliable and timely delivery for all bulk orders."
        },
        { 
            question: "What industries benefit from floor graphics printing services?", 
            answer: "Floor graphics printing services are widely used in retail, hospitality, events, and corporate marketing industries. Businesses rely on 3D floor graphics print and decals for product promotions, wayfinding, and branding. Printingy provides tailored solutions to meet the unique needs of each industry, ensuring professional and impactful results."
        },
        { 
            question: "What materials are used for floor graphics and decals?", 
            answer: "We use high-quality materials for custom floor graphic printing, including vinyl and eco-friendly options. These materials are designed for durability and resistance to wear, moisture, and sunlight. For Outdoor & Sidewalk Floor Graphics printing, we also use anti-slip coatings and UV protection to ensure safety and longevity in high-traffic or outdoor environments."
        },
        { 
            question: "Does Printingy provide design assistance for floor graphics?", 
            answer: "Yes, our custom floor graphic printing services include professional design assistance. Whether you have a concept in mind or need creative input, our design team works with you to create visually engaging and functional graphics. From font selection to colour schemes, we ensure your floor graphics align with your brand and purpose."
        },
        { 
            question: "What is the typical turnaround time for floor graphics printing?", 
            answer: "Turnaround times for floor graphics printing depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
        },
        { 
            question: "Are eco-friendly options available for floor graphics printing?", 
            answer: "Printingy is committed to sustainability and offers eco-friendly options for 3D Floor Graphics & Floor Decals. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for businesses seeking environmentally responsible printing solutions."
        },
        { 
            question: "What factors should I consider when ordering floor graphics?", 
            answer: "Consider the purpose, audience, and placement when ordering custom floor graphic printing. Choosing the right material, size, and design elements ensures your graphics are effective and visually appealing. Printingy’s team guides the process to help you create products that achieve your marketing or branding goals."
        },
        { 
            question: "How do I place an order for floor graphics printing?", 
            answer: "Placing an order is simple and efficient. Visit our website and select your preferences for floor graphics printing, including customisation options. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
        },
        { 
            question: "What makes bulk floor graphics printing cost-effective?", 
            answer: "Bulk floor graphics printing reduces per-unit costs, making it an economical choice for large-scale campaigns. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk floor graphics printing services ensure exceptional value while maintaining professional standards."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Floor Graphics');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Floor Graphics and Decals Printing Services"
  description="Professional floor graphics printing, including 3D floor graphics and decals. Bulk custom floor graphic printing for outdoor, indoor, and sidewalk applications."
  keywords="Printing of Floor Graphics,
Custom floor graphic printing,
Outdoor & Sidewalk Floor Graphics printing,
3D floor graphics print,
3D Floor Graphics & Floor Decals
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Custom Floor Graphics Printing Services</h1>
              <h2 className="text-muted">Professional printing of 3D floor graphics and decals for marketing and branding</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Floor graphics are a unique and eye-catching marketing tool that can transform any surface into an advertising platform. Printingy specialises in printing floor graphics, including 3D floor graphics print and floor decals for indoor and outdoor use.</p>
          <p>Our custom floor graphic printing solutions are perfect for retail spaces, exhibitions, sidewalks, and events. We also offer specialised Outdoor & Sidewalk Floor Graphics printing services that ensure durability and resistance to wear, even in high-traffic areas.</p>
          <p>Using advanced printing technology and premium materials, Printingy delivers vibrant and durable graphics designed to captivate your audience and enhance your brand visibility. We provide reliable and cost-effective solutions for all your floor graphic needs, from creative designs to bulk orders.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Durable Floor Graphics Printing</h2>
                <h3 className="large-hed">High-quality, customisable, and affordable floor decals and graphics</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert custom floor graphic printing for unique branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable 3D floor graphics print with vibrant colours and sharp details.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk Outdoor & Sidewalk Floor Graphics printing solutions for high-traffic areas.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials and anti-slip coatings for safety and sustainability.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced technology for long-lasting prints resistant to wear and weather.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by retailers, event organisers, and corporate clients nationwide.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Competitive pricing for large-scale orders without compromising quality.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/floorgraphics.jpg" // Path relative to the public folder
                  alt="Outdoor and sidewalk floor graphics printing"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Floor Graphics Delivered On Time</h2>
            <h3 className="small-hed">Focus on your brand while we handle your floor graphic printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with expert craftsmanship to deliver exceptional floor graphics printing services. Whether you need 3D Floor Graphics & Floor Decals for promotional campaigns or Outdoor & Sidewalk Floor Graphics printing for high-visibility areas, we ensure precision and consistency in every print.</p>
            <p>Our streamlined processes and commitment to efficiency guarantee timely delivery, even for large orders. Partner with Printingy for professional floor graphics that make a lasting impression.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default FloorGraphics;
